import { makeStyles } from "@material-ui/core";

export default makeStyles(
  (theme) => ({
    column: {
      display: "flex",
      flexDirection: "column",
      textAlign: "left",
      "& a, & p": {
        marginTop: "10px",
      },
    },
    row: {
      display: "flex",
      flexDirection: "column",
      [theme.breakpoints.up("mobile")]: {
        flexDirection: "row",
        justifyContent: "space-between",
      },
    },
    link: {
      textDecoration: "underline",
      [theme.breakpoints.up("mobile")]: {
        textAlign: "right",
      },
    },
    placeholder: {
      width: "100%",
      height: "100px",
      margin: [10, 0],
    },
    offerDescription: {
      [theme.breakpoints.up("mobile")]: {
        textAlign: "left",
        maxWidth: "330px",
      },
    },
    free: {
      textAlign: "left",
      [theme.breakpoints.up("mobile")]: {
        textAlign: "center",
      },
    },
    membershipImgWrapper: {
      margin: [20, 0],
    },
    membershipImg: {
      width: "100%",
    },
    box: {
      display: "block",
      textAlign: "center",
      margin: [10, "auto", 0],
    },
  }),
  { name: "BillingInfo" },
);
